<template></template>

<script>
import db from "../../js/db";

export default {
  name: "swal-asta-in-corso",
  components: {},
  mounted() {
    db.on("swalAstaInCorso", this.show);
  },
  destroyed() {
    db.off("swalAstaInCorso", this.show);
  },
  computed: {},
  methods: {
    show(testo) {

      Swal.fire({
        icon: "error",
        title: "Asta in corso",
        text: testo ? testo : "Azione non permessa mentre l'asta è in corso",
        confirmButtonText: "Ok, ho capito",
      });
    },
  },
};
</script>
<style></style>
